import React from "react";
import { useState } from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import NewTr from "../../common/table/newTr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import NumberFormat from "react-number-format";
import AlertIcon from "../../common/alertIcon/alertIcon";
import Button from "../../common/button/button";
import DateFnsUtils from "@date-io/date-fns";
import { ptBR } from "date-fns/locale";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { atualizarCalculoAmpliacaoPorUc } from "./../geracaoLeituraActions";

export function TabelaCalculoAmpliacao(props) {
    const [itemSelecionado, setItemSelecionado] = useState(props.itemSelecionado);
    const [calculoAmpliacao, setCalculoAmpliacao] = useState(itemSelecionado);
    const [eficienciaModulo, setEficienciaModulo] = useState(80);
    const [filtro, setFiltro] = useState({
        id_unidade_consumidora: calculoAmpliacao.id_unidade_consumidora,
        competencia_inicial: calculoAmpliacao.competencia_inicial,
        competencia_final: calculoAmpliacao.competencia_final,
    });

    const listaMesesOriginal = itemSelecionado.lista_mensal || []; //essa nunca muda, pra saber se o valor veio vazio inicialmente
    const listaMeses = calculoAmpliacao.lista_mensal || [];

    //CALCULA AS MÉDIAS USANDO OS DADOS DA LISTA ORIGINAL -------------------------------------------------------------------------------------------------------

    //percorre todos registros da lista original
    let quantidadeRegistroComConsumoFatura = 0;
    let consumoFaturaTotalRegistros = 0;
    let quantidadeRegistroComConsumoInstantaneoFatura = 0;
    let consumoInstantaneoTotalRegistros = 0;
    let listaConsumoRemotas = [];
    // for (const registroOriginal of listaMesesOriginal) {
    for (const registro of listaMeses) {
        if (registro.ignorar) continue;
        const energiaFatura = parseFloat(registro.energia_fatura) || 0;
        if (energiaFatura) {
            quantidadeRegistroComConsumoFatura++;
            consumoFaturaTotalRegistros += energiaFatura;
        }

        const consumoInstantaneo = parseFloat(registro.consumo_instantaneo_fatura) || 0;
        if (consumoInstantaneo) {
            quantidadeRegistroComConsumoInstantaneoFatura++;
            consumoInstantaneoTotalRegistros += consumoInstantaneo;
        }

        for (const remota of registro.remotas) {
            const { id, numero, consumo } = remota;
            const remotaEstaNaLista = listaConsumoRemotas.find((r) => r.id == id);
            const consumoRemota = parseFloat(consumo) || 0;
            if (!consumoRemota) continue;
            if (remotaEstaNaLista) {
                remotaEstaNaLista.quantidade++;
                remotaEstaNaLista.consumo += consumoRemota;
            } else {
                listaConsumoRemotas.push({ id, numero, quantidade: 1, consumo: consumoRemota });
            }
        }
        listaConsumoRemotas = listaConsumoRemotas.map((r) => ({ ...r, media: r.consumo / r.quantidade }));
    }

    const mediaConsumoInstantaneoFatura = quantidadeRegistroComConsumoInstantaneoFatura > 0 ? consumoInstantaneoTotalRegistros / quantidadeRegistroComConsumoInstantaneoFatura : 0;
    const mediaConsumoFatura = quantidadeRegistroComConsumoFatura > 0 ? consumoFaturaTotalRegistros / quantidadeRegistroComConsumoFatura : 0;
    //------------------------------------------------------------------------------------------------------------------------------------------------------------

    //DADOS CONTABILIZADOS A PARTIR DA LISTA POSSIVELMENTE ALTERADA PELO USUÁRIO----------------------------------------------------------------------------------
    const mesesComAlertaListaOriginal = listaMesesOriginal.find((item) => !item.energia_fatura || !item.consumo_instantaneo_fatura);
    const exibirAlertaMesFaltando = listaMeses.find((item) => !item.acumulado_energia_mes);
    const producaoUltimos12Meses = listaMeses.reduce((acc, item) => (acc += parseFloat(item.acumulado_energia_mes) || 0), 0);
    const consumoFaturaUltimos12Meses = listaMeses.reduce((acc, item) => (acc += parseFloat(item.energia_fatura) || 0), 0);
    const consumoInstantaneoFaturaUltimos12Meses = listaMeses.reduce((acc, item) => (acc += parseFloat(item.consumo_instantaneo_fatura) || 0), 0);
    const consumoRemotasUltimos12Meses = listaMeses.reduce((acc, item) => {
        return (acc += item.remotas.reduce((accRem, r) => (accRem += parseFloat(r.consumo) || 0), 0));
    }, 0);

    // const consumoInstantaneoFaturaUltimos12Meses = parseFloat(calculoAmpliacao.consumo_instantaneo_fatura_ultimos_12_meses) || 0;
    const somaConsumoFaturaConsumoInstantaneoRemotas = consumoFaturaUltimos12Meses + consumoInstantaneoFaturaUltimos12Meses + consumoRemotasUltimos12Meses;

    const diferencaConsumoAbsoluta = Math.abs(producaoUltimos12Meses - somaConsumoFaturaConsumoInstantaneoRemotas);
    const relacaoProducaoConsumo = (producaoUltimos12Meses / somaConsumoFaturaConsumoInstantaneoRemotas) * 100;
    const irradiacaoMultiplicadoEficienciaModulo = (parseFloat(calculoAmpliacao.irradiacao_media_periodo_kwh_por_m2) || 0) * (eficienciaModulo / 100);
    const diferencaProducaoConsumo = producaoUltimos12Meses - somaConsumoFaturaConsumoInstantaneoRemotas;

    return (
        <Row>
            <Grid cols="12 12 12 12" style={{ textAlign: "center" }}>
                <h4>Cálculo de Ampliação</h4>
            </Grid>
            <>
                <Grid cols="12 12 12 12" style={{ textAlign: "center" }}>
                    <h6>{itemSelecionado.nome_unidade_consumidora}</h6>
                </Grid>
                <Grid cols="12 12 4 4" style={{ fontSize: "0.85rem" }}>
                    <Table responsive>
                        <TBody>
                            <tr title={exibirAlertaMesFaltando ? "Verificar lista de histórico com dados incompletos no período selecionado" : ""}>
                                <td width="150px" className="py-2 px-3 bold" style={{ backgroundColor: "#afbbff" }}>
                                    Período:
                                </td>
                                <td className="py-2 px-3" style={{ backgroundColor: exibirAlertaMesFaltando ? "#ff7474" : "#ffffff" }}>
                                    <Grid cols="12 12 12 12">
                                        <Row>
                                            {exibirAlertaMesFaltando ? (
                                                <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                    <AlertIcon animationClass="alerta-triangulo-visualizado" />
                                                </Grid>
                                            ) : null}
                                            <Grid cols={exibirAlertaMesFaltando ? "12 12 5 5" : "12 12 6 6"}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        title={exibirAlertaMesFaltando ? "Verificar lista de histórico com dados incompletos no período selecionado" : ""}
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        label="De"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_inicial
                                                                ? `${String(filtro.competencia_inicial).substring(0, 4)}/${String(filtro.competencia_inicial).substring(
                                                                      4,
                                                                      6
                                                                  )}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_inicial: value
                                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                                    : null,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid cols={exibirAlertaMesFaltando ? "12 12 5 5" : "12 12 6 6"}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                                    <DatePicker
                                                        title={exibirAlertaMesFaltando ? "Verificar lista de histórico com dados incompletos no período selecionado" : ""}
                                                        variant="inline"
                                                        openTo="year"
                                                        views={["year", "month"]}
                                                        label="Até"
                                                        autoOk
                                                        value={
                                                            filtro.competencia_final
                                                                ? `${String(filtro.competencia_final).substring(0, 4)}/${String(filtro.competencia_final).substring(
                                                                      4,
                                                                      6
                                                                  )}/01 12:00:00`
                                                                : null
                                                        }
                                                        onChange={(value) => {
                                                            setFiltro({
                                                                ...filtro,
                                                                competencia_final: value
                                                                    ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                                    : null,
                                                            });
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                        </Row>
                                        <Row>
                                            <Grid cols="12 12 12 12">
                                                <Button
                                                    title={exibirAlertaMesFaltando ? "Verificar lista de histórico com dados incompletos no período selecionado" : ""}
                                                    style={{ margin: 0 }}
                                                    text="Buscar"
                                                    type={"primary"}
                                                    solid={true}
                                                    icon={"fa fa-search"}
                                                    event={async () => {
                                                        setItemSelecionado({ lista_mensal: [] });
                                                        setCalculoAmpliacao({ lista_mensal: [] });
                                                        const itemSelecionadoAtualizado = await atualizarCalculoAmpliacaoPorUc(filtro);
                                                        setItemSelecionado(itemSelecionadoAtualizado);
                                                        setCalculoAmpliacao(itemSelecionadoAtualizado);
                                                    }}
                                                />
                                            </Grid>
                                        </Row>
                                    </Grid>
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <td className="py-2 px-3 bold" style={{ backgroundColor: "#afbbff" }}>
                                    Cidade:
                                </td>
                                <td className="py-2 px-3">{calculoAmpliacao.cidade}</td>
                            </tr>
                            <tr>
                                <td className="py-2 px-3 bold" style={{ backgroundColor: "#afbbff" }}>
                                    Estado:
                                </td>
                                <td className="py-2 px-3">{calculoAmpliacao.estado}</td>
                            </tr>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <td
                                    className="py-2 px-3 bold"
                                    title="Distância em quilômetros entre a unidade consumidora e a localidade de referência para cálculo de irradiação solar."
                                    style={{ backgroundColor: "#afbbff" }}
                                >
                                    Distância (km):
                                </td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(calculoAmpliacao.distancia_km || 0)}</td>
                            </tr>
                        </TBody>
                    </Table>
                </Grid>
                <Grid cols="12 12 4 4" style={{ fontSize: "0.85rem" }}>
                    <Table responsive>
                        <TBody>
                            <tr style={{ backgroundColor: "#64ff9b" }}>
                                <td className="py-2 px-3 bold">Produção Acumulada no Período (kWh):</td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(producaoUltimos12Meses)}</td>
                            </tr>
                            <tr>
                                <td className="py-2 px-3 bold" style={window.innerWidth < 768 ? {} : { minWidth: 380 }}>
                                    Irradiação Média Mensal no Período (kWh/m² por dia):
                                </td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(calculoAmpliacao.irradiacao_media_periodo_kwh_por_m2 || 0)}</td>
                            </tr>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <td className="py-0 px-3 bold" style={{ verticalAlign: "middle" }}>
                                    Eficiência do módulo (%):
                                </td>
                                <td className="py-0 px-3">
                                    <div className="d-flex align-items-center">
                                        <NumberFormat
                                            style={{ height: 30 }}
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,00"}
                                            decimalSeparator={","}
                                            decimalScale={2}
                                            fixedDecimalScale={2}
                                            value={String(eficienciaModulo || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                setEficienciaModulo(valor);
                                            }}
                                        />
                                        <div className="d-flex justify-content-center align-items-end p-2">%</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="py-2 px-3 bold"> Consumo das Faturas no Período (kWh):</td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(consumoFaturaUltimos12Meses)}</td>
                            </tr>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <td className="py-2 px-3 bold"> Consumo Instantâneo no Período (kWh):</td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(consumoInstantaneoFaturaUltimos12Meses)}</td>
                            </tr>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <td className="py-2 px-3 bold"> Consumo Remotas no Período (kWh):</td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(consumoRemotasUltimos12Meses)}</td>
                            </tr>
                        </TBody>
                    </Table>
                </Grid>
                <Grid cols="12 12 4 4" style={{ fontSize: "0.85rem" }}>
                    <Table responsive>
                        <TBody>
                            <tr style={{ backgroundColor: "#ffb063" }}>
                                <td className="py-2 px-3 bold"> Constumo Total (Faturas + Instantâneo + Remotas):</td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(somaConsumoFaturaConsumoInstantaneoRemotas)}</td>
                            </tr>
                            <tr>
                                <td className="py-2 px-3 bold">Relação Produção/Consumo:</td>
                                <td className="py-2 px-3">{somaConsumoFaturaConsumoInstantaneoRemotas ? adicionarPontosMilhar(relacaoProducaoConsumo) + "%" : " - "}</td>
                            </tr>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                <td className="py-2 px-3 bold"> Diferença Produção em kWh (Produção - Consumo Total):</td>
                                <td className="py-2 px-3">{adicionarPontosMilhar(diferencaProducaoConsumo)}</td>
                            </tr>
                            {diferencaProducaoConsumo < 0 ? (
                                <>
                                    <tr>
                                        <td className="py-2 px-3 bold">
                                            <div>Valor que representa um dia dessa diferença</div>
                                            <div>{` ( ${adicionarPontosMilhar(diferencaConsumoAbsoluta)} / (12 * 30) ):`}</div>
                                        </td>
                                        <td className="py-2 px-3">{adicionarPontosMilhar(diferencaConsumoAbsoluta / (12 * 30)) + " kWh/dia"}</td>
                                    </tr>
                                    <tr style={{ backgroundColor: "#63edff" }}>
                                        <td className="py-2 px-3 bold">
                                            Potência de Ampliação{" "}
                                            {` (${adicionarPontosMilhar(diferencaConsumoAbsoluta / (12 * 30))} / (${adicionarPontosMilhar(
                                                calculoAmpliacao.irradiacao_media_periodo_kwh_por_m2 || 0
                                            )} * ${adicionarPontosMilhar(eficienciaModulo / 100)}) ): `}
                                        </td>
                                        <td className="py-2 px-3">
                                            {irradiacaoMultiplicadoEficienciaModulo
                                                ? adicionarPontosMilhar(diferencaConsumoAbsoluta / (12 * 30) / irradiacaoMultiplicadoEficienciaModulo) + " kWp"
                                                : " - "}
                                        </td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td
                                        colSpan={2}
                                        className="py-2 px-3"
                                        style={{
                                            backgroundColor: "#00d785",
                                            color: "#FFF",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 84 }}>
                                            Sem necessidade de Ampliação <i class="ml-3 fas fa-thumbs-up"></i>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </TBody>
                    </Table>
                </Grid>
                <Grid cols="12 12 12 12">
                    <Table responsive maxHeight={300}>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#FFFFFF"}>
                                {mesesComAlertaListaOriginal ? (
                                    <Th sticky alignCenter verticalAlign="top" top={-2}>
                                        Considerada Calc. Média
                                    </Th>
                                ) : null}
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Mês
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Ano
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Cidade
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Estado
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    <div title="Distância em quilômetros entre a unidade consumidora e a localidade de referência para cálculo de irradiação solar.">
                                        Distância (km)
                                    </div>
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Produção (kWh)
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Irradiação Média Mensal (kWh/m² por dia)
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Consumo da Fatura (kWh)
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Consumo Instantâneo (kWh)
                                </Th>
                                <Th sticky alignCenter verticalAlign="top" top={-2}>
                                    Consumo Remotas (kWh)
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {listaMeses.map((item, i) => {
                                const mesFaltando = (!item.acumulado_energia_mes || !item.energia_fatura || !item.consumo_instantaneo_fatura) && !item.ignorar;
                                return (
                                    <NewTr
                                        key={item.competencia}
                                        backgroundColorTr={item.ignorar ? "#333" : "#FFFFFF"}
                                        backgroundColorTd={item.ignorar ? "#333" : "#FFFFFF"}
                                        botoes={[]}
                                        highlightAlert={mesFaltando}
                                    >
                                        {mesesComAlertaListaOriginal ? (
                                            <Td alignCenter>
                                                <Button
                                                    style={{ width: 40, height: 30, padding: 0, margin: 2 }}
                                                    title={item.ignorar ? "Considerar linha novamente no cálculo de média" : `Desconsiderar linha do cálculo de média`}
                                                    icon={item.ignorar ? "fas fa-toggle-off" : "fas fa-toggle-on"}
                                                    type={item.ignorar ? "light" : "primary"}
                                                    event={() => {
                                                        setCalculoAmpliacao({
                                                            ...calculoAmpliacao,
                                                            lista_mensal: listaMeses.map((lm, indice) => (indice == i ? { ...lm, ignorar: !lm.ignorar } : lm)),
                                                        });
                                                    }}
                                                />
                                            </Td>
                                        ) : null}
                                        <Td color={item.ignorar ? "#FFFFFF" : "#222222"} alignCenter>
                                            <div>{item.mes}</div>
                                        </Td>
                                        <Td color={item.ignorar ? "#FFFFFF" : "#222222"} alignCenter>
                                            <div>{item.ano}</div>
                                        </Td>
                                        <Td color={item.ignorar ? "#FFFFFF" : "#222222"} alignCenter>
                                            <div>{item.cidade}</div>
                                        </Td>
                                        <Td color={item.ignorar ? "#FFFFFF" : "#222222"} alignCenter>
                                            <div>{item.estado}</div>
                                        </Td>
                                        <Td color={item.ignorar ? "#FFFFFF" : "#222222"} alignCenter>
                                            <div>{adicionarPontosMilhar(item.distancia_km) + " km"}</div>
                                        </Td>
                                        <Td  color={item.ignorar ? "#FFFFFF" : "#222222"}  alignCenter>
                                            <div>
                                                {listaMesesOriginal[i].acumulado_energia_mes ? (
                                                    adicionarPontosMilhar(item.acumulado_energia_mes) + " kWh"
                                                ) : (
                                                    <div className="d-flex align-items-center" style={{ maxWidth: 190 }}>
                                                        <Button
                                                            style={{ width: 40, height: 30, padding: 0, margin: 2 }}
                                                            title={
                                                                item.acumulado_energia_mes
                                                                    ? "Remover valor de produção esperada"
                                                                    : `Completar com o valor de produção esperado definido no cadastro`
                                                            }
                                                            icon={item.acumulado_energia_mes ? "fas fa-times" : "fas fa-calculator"}
                                                            type={item.acumulado_energia_mes ? "danger" : "info"}
                                                            event={() => {
                                                                setCalculoAmpliacao({
                                                                    ...calculoAmpliacao,
                                                                    lista_mensal: listaMeses.map((lm, indice) =>
                                                                        indice == i
                                                                            ? { ...lm, acumulado_energia_mes: item.acumulado_energia_mes ? 0 : item.producao_esperada_mes }
                                                                            : lm
                                                                    ),
                                                                });
                                                            }}
                                                        />
                                                        <NumberFormat
                                                            style={{ height: 30, boxShadow: item.acumulado_energia_mes ? "none" : "0px 0px 5px 1px #ff0404" }}
                                                            className="form-control"
                                                            disabled={false}
                                                            placeholder={"0,00"}
                                                            decimalSeparator={","}
                                                            decimalScale={2}
                                                            fixedDecimalScale={2}
                                                            value={String(item.acumulado_energia_mes || 0).replace(".", ",")}
                                                            onValueChange={(values) => {
                                                                const acumulado_energia_mes = values.floatValue || 0;
                                                                setCalculoAmpliacao({
                                                                    ...calculoAmpliacao,
                                                                    lista_mensal: listaMeses.map((lm, indice) => (indice == i ? { ...lm, acumulado_energia_mes } : lm)),
                                                                });
                                                            }}
                                                        />
                                                        <div className="d-flex justify-content-center align-items-end p-2">kWh</div>
                                                    </div>
                                                )}
                                            </div>
                                        </Td>
                                        <Td color={item.ignorar ? "#FFFFFF" : "#222222"} alignCenter>
                                            <div>{adicionarPontosMilhar(item.media_mensal_wh_por_m2 / 1000) + " kWh/m².dia"}</div>
                                        </Td>
                                        <Td  color={item.ignorar ? "#FFFFFF" : "#222222"}  alignCenter>
                                            {listaMesesOriginal[i].energia_fatura ? (
                                                adicionarPontosMilhar(item.energia_fatura) + " kWh"
                                            ) : (
                                                <div className="d-flex align-items-center" style={{ maxWidth: 190 }}>
                                                    <Button
                                                        style={{ width: 40, height: 30, padding: 0, margin: 2 }}
                                                        title={item.energia_fatura ? "Remover valor médio" : `Completar com a média dos meses listados`}
                                                        icon={item.energia_fatura ? "fas fa-times" : "fas fa-calculator"}
                                                        type={item.energia_fatura ? "danger" : "info"}
                                                        event={() => {
                                                            setCalculoAmpliacao({
                                                                ...calculoAmpliacao,
                                                                lista_mensal: listaMeses.map((lm, indice) =>
                                                                    indice === i ? { ...lm, energia_fatura: item.energia_fatura ? 0 : mediaConsumoFatura } : lm
                                                                ),
                                                            });
                                                        }}
                                                    />
                                                    <NumberFormat
                                                        style={{ height: 30, boxShadow: item.energia_fatura ? "none" : "0px 0px 5px 1px #ff0404" }}
                                                        className="form-control"
                                                        disabled={false}
                                                        placeholder={"0,00"}
                                                        decimalSeparator={","}
                                                        decimalScale={2}
                                                        fixedDecimalScale={2}
                                                        value={String(item.energia_fatura || 0).replace(".", ",")}
                                                        onValueChange={(values) => {
                                                            const energia_fatura = values.floatValue || 0;
                                                            setCalculoAmpliacao({
                                                                ...calculoAmpliacao,
                                                                lista_mensal: listaMeses.map((lm, indice) => (indice === i ? { ...lm, energia_fatura } : lm)),
                                                            });
                                                        }}
                                                    />
                                                    <div className="d-flex justify-content-center align-items-end p-2">kWh</div>
                                                </div>
                                            )}
                                        </Td>
                                        <Td  color={item.ignorar ? "#FFFFFF" : "#222222"}  alignCenter>
                                            {listaMesesOriginal[i].consumo_instantaneo_fatura ? (
                                                adicionarPontosMilhar(item.consumo_instantaneo_fatura) + " kWh"
                                            ) : (
                                                <div className="d-flex align-items-center" style={{ maxWidth: 190 }}>
                                                    <Button
                                                        style={{ width: 40, height: 30, padding: 0, margin: 2 }}
                                                        title={item.consumo_instantaneo_fatura ? "Remover valor médio" : `Completar com a média dos meses listados`}
                                                        icon={item.consumo_instantaneo_fatura ? "fas fa-times" : "fas fa-calculator"}
                                                        type={item.consumo_instantaneo_fatura ? "danger" : "info"}
                                                        event={() => {
                                                            setCalculoAmpliacao({
                                                                ...calculoAmpliacao,
                                                                lista_mensal: listaMeses.map((lm, indice) =>
                                                                    indice === i
                                                                        ? { ...lm, consumo_instantaneo_fatura: item.consumo_instantaneo_fatura ? 0 : mediaConsumoInstantaneoFatura }
                                                                        : lm
                                                                ),
                                                            });
                                                        }}
                                                    />
                                                    <NumberFormat
                                                        style={{ height: 30, boxShadow: item.consumo_instantaneo_fatura ? "none" : "0px 0px 5px 1px #ff0404" }}
                                                        className="form-control"
                                                        disabled={false}
                                                        placeholder={"0,00"}
                                                        decimalSeparator={","}
                                                        decimalScale={2}
                                                        fixedDecimalScale={2}
                                                        value={String(item.consumo_instantaneo_fatura || 0).replace(".", ",")}
                                                        onValueChange={(values) => {
                                                            const consumo_instantaneo_fatura = values.floatValue || 0;
                                                            setCalculoAmpliacao({
                                                                ...calculoAmpliacao,
                                                                lista_mensal: listaMeses.map((lm, indice) => (indice === i ? { ...lm, consumo_instantaneo_fatura } : lm)),
                                                            });
                                                        }}
                                                    />
                                                    <div className="d-flex justify-content-center align-items-end p-2">kWh</div>
                                                </div>
                                            )}
                                        </Td>
                                        <Td width="330px" alignCenter>
                                            {item.remotas.length ? (
                                                <ul>
                                                    {item.remotas.map((r, ir) => {
                                                        return (
                                                            <li style={{ textAlign: "left" }}>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="mx-2"> {"UC " + r.numero + " - "}</span>
                                                                    {listaMesesOriginal[i].remotas[ir].consumo ? (
                                                                        adicionarPontosMilhar(r.consumo) + " kWh"
                                                                    ) : (
                                                                        <div className="d-flex align-items-center" style={{ maxWidth: 150 }}>
                                                                            <Button
                                                                                style={{ width: 40, height: 30, padding: 0, margin: 2 }}
                                                                                title={r.consumo ? "Remover valor médio" : `Completar com a média dos meses listados`}
                                                                                icon={r.consumo ? "fas fa-times" : "fas fa-calculator"}
                                                                                type={r.consumo ? "danger" : "info"}
                                                                                event={() => {
                                                                                    const consumoMedioRemota = listaConsumoRemotas.find(
                                                                                        (remotaOriginal) => remotaOriginal.id == r.id
                                                                                    );
                                                                                    const consumo = r.consumo ? 0 : consumoMedioRemota ? consumoMedioRemota.media : 0;
                                                                                    setCalculoAmpliacao({
                                                                                        ...calculoAmpliacao,
                                                                                        lista_mensal: listaMeses.map((lm, indice) =>
                                                                                            indice === i
                                                                                                ? {
                                                                                                      ...lm,
                                                                                                      remotas: lm.remotas.map((rem, irem) =>
                                                                                                          irem === ir ? { ...rem, consumo } : rem
                                                                                                      ),
                                                                                                  }
                                                                                                : lm
                                                                                        ),
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <NumberFormat
                                                                                style={{ height: 30, boxShadow: r.consumo ? "none" : "0px 0px 5px 1px #ff0404" }}
                                                                                className="form-control"
                                                                                disabled={false}
                                                                                placeholder={"0,00"}
                                                                                decimalSeparator={","}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={2}
                                                                                value={String(r.consumo || 0).replace(".", ",")}
                                                                                onValueChange={(values) => {
                                                                                    const consumo = values.floatValue || 0;
                                                                                    setCalculoAmpliacao({
                                                                                        ...calculoAmpliacao,
                                                                                        lista_mensal: listaMeses.map((lm, indice) =>
                                                                                            indice === i
                                                                                                ? {
                                                                                                      ...lm,
                                                                                                      remotas: lm.remotas.map((rem, irem) =>
                                                                                                          irem === ir ? { ...rem, consumo } : rem
                                                                                                      ),
                                                                                                  }
                                                                                                : lm
                                                                                        ),
                                                                                    });
                                                                                }}
                                                                            />
                                                                            <div className="d-flex justify-content-center align-items-end p-2">kWh</div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            ) : (
                                                " - "
                                            )}
                                        </Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </Grid>
            </>
        </Row>
    );
}
